import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { ConferenceResponse } from "~types/conference.ts";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

export const SelectConference = ({ value, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: ConferenceResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameLocal, value: x.conferenceId }));

  return (
    <InfinitySelect<ConferenceResponse>
      {...props}
      url={`${sport}/o/${organizationId}/conferences`}
      searchParameter="nameLocalContains"
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.CONFERENCE}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
